import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestTeethAlignersWrapper from "@components/layouts/bestteethalignersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <BestTeethAlignersWrapper>
            <PrivacyPolicy
                category="Teeth Aligners"
                domain="bestteethaligners.com"
            />
        </BestTeethAlignersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
